export const LOADING = 'userProfile.LOADING';
export const LOADED = 'userProfile.LOADED';
